// extracted by mini-css-extract-plugin
export default {"sidebar":"t_b3","sidebarHeader":"t_b4","fileinput":"t_b5","form":"t_b6","sponsoredText":"t_b7"};